import { useInjection } from 'inversify-react';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { IAnnotationUiStore } from '../annotationUi.store';
import { ZoomControl } from '../components/ZoomControl';

export const ZoomContainer = observer((): ReactElement => {
  const annotationUiStore = useInjection(IAnnotationUiStore.$);

  const handleZoomLevelChange = (zoomLevel: number): void => {
    annotationUiStore.changeZoomLevel(zoomLevel);
  };

  return (
    <ZoomControl
      onZoomLevelChange={handleZoomLevelChange}
      zoomValue={annotationUiStore.zoomLevel}
      minZoomLevel={annotationUiStore.minZoomLevel}
      maxZoomLevel={annotationUiStore.maxZoomLevel}
    />
  );
});
